// prettier-ignore
export default {
    "FILE_NOT_PDF": "File non valido, formati supportati sono pdf, jpeg, png, webp",
    "FILE_NOT_FOUND": "The file is not on the server",
    "GENERIC_ERROR": "Errore generico",
    "BROWSER_ERROR": "Il browser non supporta questo comando",
    "CONNECTION_ERROR": "Errore di connessione, se il problema persiste disabilitare estensioni del browser (in particolare Kaspersky Antivirus) e riprovare."
}